// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"aa5d3e87","703":"42088e6b","787":"d7049db1"}[chunkId] + ".chunk.js";
};